/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Defect_HintInputs */

const vi_confirm_return_defect_hint = /** @type {(inputs: Confirm_Return_Defect_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick dòng có hàng lỗi và nhập số lượng lỗi. Phần tốt và phần lỗi nhập về kệ đã chọn bên dưới mỗi lô.`)
};

/**

* @param {Confirm_Return_Defect_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_defect_hint = /** @type {((inputs?: Confirm_Return_Defect_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Defect_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_defect_hint(inputs)
});